<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M26 7H22.535L20.8312 4.445C20.74 4.30819 20.6164 4.196 20.4714 4.11838C20.3264 4.04076 20.1645 4.0001 20 4H12C11.8355 4.0001 11.6736 4.04076 11.5286 4.11838C11.3836 4.196 11.26 4.30819 11.1687 4.445L9.46375 7H6C5.20435 7 4.44129 7.31607 3.87868 7.87868C3.31607 8.44129 3 9.20435 3 10V24C3 24.7956 3.31607 25.5587 3.87868 26.1213C4.44129 26.6839 5.20435 27 6 27H26C26.7956 27 27.5587 26.6839 28.1213 26.1213C28.6839 25.5587 29 24.7956 29 24V10C29 9.20435 28.6839 8.44129 28.1213 7.87868C27.5587 7.31607 26.7956 7 26 7ZM20.5 16.5C20.5 17.39 20.2361 18.26 19.7416 19.0001C19.2471 19.7401 18.5443 20.3169 17.7221 20.6575C16.8998 20.9981 15.995 21.0872 15.1221 20.9135C14.2492 20.7399 13.4474 20.3113 12.818 19.682C12.1887 19.0526 11.7601 18.2508 11.5865 17.3779C11.4128 16.505 11.5019 15.6002 11.8425 14.7779C12.1831 13.9557 12.7599 13.2529 13.4999 12.7584C14.24 12.2639 15.11 12 16 12C17.1935 12 18.3381 12.4741 19.182 13.318C20.0259 14.1619 20.5 15.3065 20.5 16.5Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: "CameraIcon",
};
</script>
